import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { Observable, catchError, map } from 'rxjs';
import { GridRequestCommand } from '../commands/grid-request.command';
import { GridToggleCommand } from '../commands/grid-toggle.command';
import { GridRequestMethod } from '../enums/grid-request-method.enum';
import { transformError } from '../functions/common.function';
import { GridRequestConfiguration } from '../models/grid-request-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class GridRequestService {
  constructor(private readonly httpRequestService: HttpRequestService) {}

  /**
   * Obtiene información páginada para la carga del Grid
   *
   * @param requestUrl - URL del API para la obtención de datos paginados
   * @param requestData - Valores para realizar el paginado de la información
   */
  getGridData<TResponse>(request: GridRequestConfiguration, command: GridRequestCommand): Observable<HttpServerResponse<TResponse>> {
    switch (request.method) {
      case GridRequestMethod.GET:
        return this.httpRequestService.get<TResponse>(request.url, command, { formatErrors: false });
      case GridRequestMethod.POST:
      default:
        return this.httpRequestService.post<TResponse>(request.url, command, { formatErrors: false });
    }
  }

  /**
   * Cambia el valor de control de un registro especifico
   *
   * @param requestUrl - URL del API con el método para cambiar estatus
   * @param command - Información y nuevo valor para el cambio del campo
   */
  changeToggleValue(path: ProxyContext, command: GridToggleCommand): Observable<HttpServerResponse<unknown>> {
    return this.httpRequestService.post<unknown>(path, command).pipe(
      map((response) => {
        return response;
      }),
      catchError(transformError)
    );
  }
}
